import { useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";

// img
// import logo from "../../../assets/svg/jiophotos-logo.svg";
// import logo from "../../../assets/svg/jcevents-logo.svg";
// import jioSnapLogo from "../../../assets/svg/Jiosnap.svg";
import logo from "../../../assets/png/JioCloud-Logo.png";

// css
import classes from "./Header.module.css";
import Navbar from "./Navbar";
import { Stack } from "@mui/material";
import { Text } from "@jds/core";

export default function Header(props) {
  const location = useLocation().pathname;
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const loginDetails = useSelector((state) => state.auth.loginDetails);
  const isJitoUser = loginDetails?.userType === "JITO";
  return (
    <>
      <header className="header">
        <div className={classes["header__container"]}>
          {!isJitoUser ? (
            <NavLink
              // to={!isAuthenticated ? "/" : "/home"}
              to={`${process.env.REACT_APP_JIOCLOUD_HOME_URL}`}
              className={classes["header__logo-box"]}>
              <Stack direction="row" gap={1} alignItems="center">
                <img
                  src={logo}
                  alt="jio photos logo"
                  style={{ width: "40px" }}
                />
                <div>
                  <Text
                    text="JioPhotos"
                    appearance="body-m-bold"
                    color="white"
                  />
                  <Text
                    text="storage partner JioAICloud"
                    appearance="body-xxs"
                    color="white"
                  />
                </div>
              </Stack>
            </NavLink>
          ) : (
            <Stack direction="row" gap={1} alignItems="center">
              <img src={logo} alt="jio photos logo" style={{ width: "40px" }} />
              <div>
                <Text text="JioPhotos" appearance="body-m-bold" color="white" />
                <Text
                  text="&nbsp; &nbsp;storage partner JioAICloud"
                  appearance="body-xxs"
                  color="white"
                />
              </div>
            </Stack>
          )}
          <Navbar />
        </div>
        {location === "/home" && (
          <div className={classes["sub-header"]}>
            <span
              style={{
                color: "#0C293B",
                fontSize: "18px",
                fontFamily: "JioType-Medium",
              }}>
              PhotoShare
            </span>
          </div>
        )}
      </header>
    </>
  );
}
